import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginApi } from "../../services/authService";

const getStoredUser = () => {
  try {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  } catch {
    localStorage.removeItem("user");
    return null;
  }
};

const initialState = {
  token: localStorage.getItem("access_token") || null,
  user: getStoredUser(),
  status: "idle",
  error: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const result = await loginApi({ username, password });

      // Handle cases where the API returns a 200 OK but indicates an error in the payload
      if (result?.meta?.status === false) {
        return rejectWithValue(result);
      }

      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.status = "idle";
      state.error = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("user_location");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        const token = action.payload?.data?.access_token || null;
        state.token = token;
        state.user = action.payload?.data || null;
        if (token) localStorage.setItem("access_token", token);
        if (state.user) localStorage.setItem("user", JSON.stringify(state.user));
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          action.payload?.meta?.message ||
          action.payload?.message ||
          "Login failed";
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;

